function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
export { _OverloadYield as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/helpers/esm/OverloadYield.js
// module id = ./node_modules/@babel/runtime/helpers/esm/OverloadYield.js
// module chunks = 0